export const TRAININGINFO_REQUEST = 'TRAININGINFO_REQUEST';
export const TRAININGINFO_SUCCESS = 'TRAININGINFO_SUCCESS';
export const TRAININGINFO_ERROR   = 'TRAININGINFO_ERROR';


export const REGINFO_REQUEST ="REGINFO_REQUEST";
export const REGINFO_SUCCESS ="REGINFO_SUCCESS";
export const REGINFO_ERROR   ="REGINFO_ERROR";